const CommentVisibility = {
	PUBLIC: "0", // visible to all, e.g. admin messages.
	PROTECTED: "1", // visible to self (and geollect comment admins)
	PRIVATE: "2" // visible to self (and nobody else)
};
CommentVisibility.toName = (visibility) => {
	const map = {
		[CommentVisibility.PUBLIC]: "Public",
		[CommentVisibility.PROTECTED]: "Private",
		[CommentVisibility.PRIVATE]: "Private"
	};
	return map[visibility];
};
CommentVisibility.toDescription = (visibility) => {
	const map = {
		[CommentVisibility.PUBLIC]: "Visible to all Geonius users",
		[CommentVisibility.PROTECTED]: "Visible company-wide, and to Geollect",
		[CommentVisibility.PRIVATE]: "Visible company-wide"
	};
	return map[visibility];
};
export default CommentVisibility;
